import { api } from '@/api/index'
// import { groupLoop } from '@/utils/index'

const state = {}

const mutations = {
  RESET(state) {
    for (const key in state) {
      state[key] = null
    }
    state = {}
  },
  UPDATE: (state, data) => {
    state[data.field] = data.data
  },
}

const actions = {
  // 获取字典
  data({ commit, state }, url) {
    const field = btoa(url)
    const dictData = state[field]
    return new Promise((resolve, reject) => {
      if (dictData && url.indexOf('update') == -1) {
        resolve(dictData)
      } else {
        api
          .get(url)
          .then(res => {
            let resData = res.data || []
            commit('UPDATE', { field: field, data: resData })
            resolve(resData)
          })
          .catch(err => {
            resolve([])
          })
      }
    })
  },
  // // 获取字典
  // data({ commit, state }, data) {
  //   const field = btoa(JSON.stringify(data))
  //   const dictData = state[field]
  //   return new Promise((resolve, reject) => {
  //     if (dictData) {
  //       resolve(dictData)
  //     } else {
  //       api
  //         .get(data.url, data.search || {})
  //         .then(res => {
  //           let resData = res.data || []
  //           commit('UPDATE', { field: field, data: resData })
  //           resolve(resData)
  //         })
  //         .catch(err => {
  //           resolve([])
  //         })
  //     }
  //   })
  // },
  // 获取字典
  // func({ commit, state }, code) {
  //   const data = { url: 'dict/data', search: { func: code } }
  //   const field = btoa(JSON.stringify(data))
  //   const dictData = state[field]
  //   return new Promise((resolve, reject) => {
  //     if (dictData) {
  //       resolve(dictData)
  //     } else {
  //       api
  //         .get(data.url, data.search || {})
  //         .then(res => {
  //           let resData = res.data || []
  //           commit('UPDATE', { field: field, data: resData })
  //           resolve(resData)
  //         })
  //         .catch(err => {
  //           resolve([])
  //         })
  //     }
  //   })
  // },
  // 查找字典
  item({ commit, state }, arr) {
    return new Promise((resolve, reject) => {
      this.dispatch('dict/data', arr[0]).then(res => {
        let resData = {}
        dataLoop(res)
        function dataLoop(list) {
          for (const element of list) {
            if (element.id == arr[1]) {
              resData = element
              break
            }
            if (element.children && element.children.length > 0) {
              dataLoop(element.children)
            }
          }
        }
        resolve(resData)
      })
    })
  },
  // 重置
  reset({ commit, state }) {
    commit('RESET')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
